import { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ITQModal } from "../../libs/ITQModal";

import {
  MenuBurgerIcon,
  WalletIcon,
  LogoutIcon,
  PathJoinerIcon,
  AdWhatsappIcon,
} from "../../libs/SVGIcons";

import { Button, LinearProgress } from "@material-ui/core";

import {
  logoutUser,
  handleAppError,
  setLoading,
  setAgencyBalance,
  setAgencyCredit,
  setAgencyPercentage,
  setAgencyProfit,
  setAgencyInfo,
} from "../../actions";

import { ErrorBoundary } from "react-error-boundary";

import {
  LanguageSelector,
  ITQNotifications,
  OfflineStorageKeyAllowAutoRefresh,
  AppPathNames,
  AppAgencyMenu,
} from "../../libs";
import { database } from "../../libs/estrylib/Firebase";
import Menu from "../Sidebar/components/Menu";
import ForFallBack from "../../libs/ForFallBack";
import AppConfig from "../../constants/AppConfig";
import Chatra from "@chatra/chatra";
import $ from "jquery";
import { OfflineStorage } from "../../libs/estrylib";
import Avatar from "./avatar";
import { AppAdminMenu } from "../../libs/AppAdminMenu";

class MainApp extends Component {
  state = {
    activeMenuItemIndex: 1, //starts from 0
    menu: null,
    adminMenu: null,
    showSignalsPopup: false,
    sidebarMenuHeight: "380px",
  };
  firebaseListener = null;
  signalsFirebaseListener = null;
  ref = null;
  signalsRef = null;

  componentDidMount() {
    // document.onkeypress = function () {};
    // document.onkeydown = function () {};
    let sidebarMenuHeight = window.innerHeight - 350;
    const indexObj = this;
    window.addEventListener("resize", function () {
      sidebarMenuHeight = window.innerHeight - 350;
      indexObj.setState({
        sidebarMenuHeight: sidebarMenuHeight + "px",
      });
    });

    window.burgerButtonClicked = this.burgerButtonClicked;
    window.toggleTableFilterMenu = this.toggleTableFilterMenu;
    const {
      agency_id,
      user_id,
      name,
      live_chat_id,
    } = this.props.user;

    this.setState({
      sidebarMenuHeight: sidebarMenuHeight + "px",
    });
    if (!this.ref) {
      const ref = database.ref().child("blns").child(agency_id);
      ref.onDisconnect().set("none");
      this.ref = ref;
      const signalsRef = database.ref().child("signals").child(user_id);
      this.signalsRef = signalsRef;
      this.registerFirebaseEvent();
    }
    let config = {
      integration: {
        name: name,
      },
      setup: {
        clientId: live_chat_id,
      },
      ID: "kcBySkByW43aojKK9",
    };
    Chatra("init", config);
  }
  componentWillUnmount() {
    this.unRegisterFirebaseEvent();
  }
  firebaseListenerFunction(snapshot) {
    console.log("agency related values changed ...");
    const { setAgencyInfo } = this.props;
    const recordValue = snapshot.val();
    if (this.props.user.is_super_admin) {
      recordValue.profit = recordValue.netprofit;
    }
    setAgencyInfo(recordValue);
  }
  signalsFirebaseListenerFunction(snapshot) {
    console.log("new signal reached ...");
    const signalType = snapshot.val().split(";")[0];
    if (signalType === "RolesUpdated") {
      this.setState({
        showSignalsPopup: true,
      });
    }
    if (signalType === "BrowserRefresh") {
      if (
        window.location.href.includes("view-received") ||
        window.location.href.includes("insurance-requests/view-all")
      ) {
        if (OfflineStorage.instance.get(OfflineStorageKeyAllowAutoRefresh)) {
          window.location.reload();
        }
      }
    }
  }
  registerFirebaseEvent() {
    console.log("registering firebase event ...");
    this.firebaseListener = this.ref.on(
      "value",
      this.firebaseListenerFunction.bind(this)
    );
    this.signalsFirebaseListener = this.signalsRef.on(
      "child_changed",
      this.signalsFirebaseListenerFunction.bind(this)
    );
    this.props.setLoading(false);
  }
  unRegisterFirebaseEvent() {
    console.log("unregistering firebase event ...");
    this.firstLoad = true;
    this.ref.off("child_changed");
    this.signalsRef.off("child_changed");
  }
  renderPage() {
    const { children } = this.props;
    return <div className="container-fluid page-container">{children}</div>;
  }
  burgerButtonClicked(onlyIfClosed = false) {
    console.log("burger button clicked fired ...");
    document
      .getElementsByClassName("sidebar-container")[0]
      .classList.toggle("sidebar-container-show");
    if (window.innerWidth <= 576) {
      window.setTimeout(function () {
        $(window).click(function (e) {
          console.log("window clicked ...");
          if ($(".sidebar-container").hasClass("sidebar-container-show")) {
            console.log("hiding sidebar ...");
            const specifiedElement =
              document.getElementsByClassName("sidebar-container")[0];
            const isClickInside = specifiedElement.contains(e.target);
            if (!isClickInside) {
              $(".sidebar-container").removeClass("sidebar-container-show");
              $(window).unbind("click");
            }
          }
        });
      }, 300);
    } else {
      if (onlyIfClosed && !$(".sidebar-bg").hasClass("closed")) {
        return;
      }
      if (!$(".sidebar-bg").hasClass("closed")) {
        $(".menu-item-n .angle").removeClass("active");
        $(".menu-item-n .sub-menu").removeClass("show");
      }
      $(".sidebar-bg").toggleClass("closed");
      //remove classes
      $(".s-top-bar").toggleClass("offset-md-3");
      $(".s-top-bar").toggleClass("offset-lg-3");
      $(".s-top-bar").toggleClass("offset-xl-2");

      $(".s-main-content").toggleClass("offset-md-3");
      $(".s-main-content").toggleClass("offset-lg-3");
      $(".s-main-content").toggleClass("offset-xl-2");
      //add classes
      $(".s-top-bar").toggleClass("offset-md-2");
      $(".s-top-bar").toggleClass("offset-lg-1");
      $(".s-top-bar").toggleClass("offset-xl-1");

      $(".s-main-content").toggleClass("offset-md-2");
      $(".s-main-content").toggleClass("offset-lg-1");
      $(".s-main-content").toggleClass("offset-xl-1");
    }
  }
  toggleTableFilterMenu() {
    $("#itqan_table_filters_top_container").toggleClass("itqan-mobile-hide");
    $(".itqan-overlay").toggleClass("show");
    window.setTimeout(function () {
      $(window).click(function (e) {
        console.log("window clicked ...");
        if (
          !$("#itqan_table_filters_top_container").hasClass("itqan-mobile-hide")
        ) {
          console.log("hiding sidebar ...");
          const specifiedElement = document.getElementById(
            "itqan_table_filters_top_container"
          );
          const isClickInside = specifiedElement.contains(e.target);
          if (!isClickInside) {
            $("#itqan_table_filters_top_container").toggleClass(
              "itqan-mobile-hide"
            );
            $(".itqan-overlay").toggleClass("show");
            $(window).unbind("click");
          }
        }
      });
    }, 300);
  }
  renderHeader() {
    const {
      agency_id,
      user_id,
      name,
      lang,
      is_root_agency,
      agency_balance,
      system_currency,
      profile_picture,
    } = this.props.user;
    const { history, handleAppError, setLoading } = this.props;
    //change html lang attribute
    document.documentElement.setAttribute("lang", lang);
    return (
      <div
        className="container-fluid header"
        style={{ position: "fixed", width: "100%", zIndex: "2" }}
      >
        <div className="row justify-content-between">
          <div className="col-5 col-md-3 offset-md-3 col-lg-2 offset-lg-3 col-xl-2 offset-xl-2 d-flex align-items-center px-0 s-top-bar">
            <div className="col-2 offset-1 offset-sm-0">
              <div
                className="burger-button-container"
                onClick={() => {
                  window.burgerButtonClicked();
                }}
              >
                <MenuBurgerIcon className="clickable" />
              </div>
            </div>
            <div className="col-9">
              <span
                onClick={() => {
                  history.push("/app/balance-requests/view-all");
                }}
                className="clickable"
              >
                <WalletIcon /> {!is_root_agency && <b>{agency_balance + " " + system_currency}</b>}
              </span>
            </div>
          </div>

          <div className="col-7 col-md-6 col-lg-5 col-xl-4 d-flex justify-content-between header-right-section align-items-center">
            <LanguageSelector
              lang={lang}
              handleAppError={handleAppError}
              setLoading={setLoading}
            />
            {/* <div className="messages d-flex align-items-center">
              <MessagingIcon className="icon" />
            </div> */}
            <div className="notifications d-flex align-items-center">
              <ITQNotifications
                userId={user_id}
                agencyId={agency_id}
                lang={lang}
              />
            </div>
            <Avatar profile_picture={profile_picture} props={this.props} />
          </div>
        </div>
      </div>
    );
  }
  renderSidebar() {
    const { lang, agency_logo, root_agency_logo, is_root_agency, permissions, is_super_admin } = this.props.user;
    const { sidebarMenuHeight } = this.state;
    const { history } = this.props;
    const menu = is_root_agency
      ? AppAdminMenu(permissions, lang, is_super_admin)
      : AppAgencyMenu(permissions, lang);
    return (
      <div
        className="container-fluid sidebar-bg px-0 mx-0"
        style={{ position: "fixed" }}
      >
        <div className="row">
          <div className="col-12 px-0">
            <div className="logo-container d-flex justify-content-center">
              {/* TODO: Check or modify brand logo */}
              {/* <img
                src={
                  agency_logo
                    ? AppConfig.storagePath + agency_logo
                    : AppConfig.storagePath + root_agency_logo
                }
                alt="Insurances System Logo"
                className="sidebar-logo"
                onClick={() => {
                  history.push("/app/home");
                }}
                style={{ cursor: "pointer" }}
              /> */}
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-12 d-flex justify-content-center sidebar-menu-container"
            style={{ height: sidebarMenuHeight }}
          >
            <div className="sidebar-menu">
              {menu && <Menu menuItems={menu} handler={() => { }} />}
            </div>
          </div>
        </div>
        <div className="row sidebar-logout-part">
          <div className="col-12">
            <div className="d-flex align-items-end h-100 justify-content-center">
              <Button
                variant="contained"
                className="sidebar-logout-btn inter inter-semi-bold"
                onClick={() => {
                  this.props.setLoading(true);
                  this.props.logoutUser();
                }}
              >
                <LogoutIcon
                  style={
                    lang === "ar"
                      ? {
                        marginLeft: "5px",
                        width: "10px",
                      }
                      : {
                        marginRight: "5px",
                        width: "10px",
                      }
                  }
                />
                <span className="logout-title">
                  {window.sys_app_translate("Logout", lang)}
                </span>
              </Button>
            </div>
          </div>
        </div>
        <div className="sidebar-bottom-bg"></div>
      </div>
    );
  }
  errorFallback(props) {
    return <ForFallBack {...props} />;
    // return (
    //   <div role="alert">
    //     <p>Something went wrong:</p>
    //     <pre>{error.message}</pre>
    //     <button onClick={resetErrorBoundary}>Try again</button>
    //   </div>
    // );
  }
  renderSignalsPopup() {
    const { showSignalsPopup } = this.state;
    const { lang } = this.props.user;
    return (
      <ITQModal
        isOpen={showSignalsPopup}
        viewMode={true}
        isCenterd={true}
        size="sm"
        title={window.sys_app_translate("Important Update!", lang)}
        bodyContent={
          <>
            <div className="text-center">
              {window.sys_app_translate(
                "Your user is affected by new changes, you must logout"
              )}
            </div>
            <div className="text-center" style={{ marginTop: "35px" }}>
              <Button
                variant="contained"
                className="sidebar-logout-btn"
                onClick={() => {
                  this.props.setLoading(true);
                  this.props.logoutUser();
                }}
              >
                <LogoutIcon
                  style={{
                    marginRight: "5px",
                    width: "10px",
                  }}
                />
                {window.sys_app_translate("Logout", lang)}
              </Button>
            </div>
          </>
        }
        showFooter={true}
      />
    );
  }
  render() {
    const { loading, history } = this.props;
    const { lang } = this.props.user;
    console.log("rendering content ...");
    let lockLoadingPage = false;
    switch (history.location.pathname) {
      case "/app/insurance-requests/create":
      case "/app/financial-requests/view-all":
      case "/app/balance-requests/view-all":
      case "/app/expenses/view-all":
      case "/app/announcements/view-all":
      case "/app/expenses/create":
        lockLoadingPage = false;
        break;
    }
    return (
      <ErrorBoundary FallbackComponent={this.errorFallback} onReset={() => { }}>
        {loading && (
          <div
            className="container-fluid"
            style={{ position: "fixed", zIndex: "100000" }}
          >
            <LinearProgress color="primary" />
            <LinearProgress color="primary" />
          </div>
        )}
        <div className="container-fluid" style={{ position: "relative" }}>
          {loading && lockLoadingPage ? (
            <div
              style={{
                background: "white",
                position: "absolute",
                opacity: "0.4",
                width: "100%",
                height: "100vh",
                zIndex: "9998",
              }}
            ></div>
          ) : null}
          <div className="row">
            <div className="col-sm-12 px-0 sidebar-container">
              {this.renderSidebar()}
            </div>
            <div className="col-12 px-0">
              <div className="row">
                <div className="col-12 px-0">{this.renderHeader()}</div>
              </div>
            </div>
            <div className="col-12 col-md-8 offset-md-3 col-lg-8 offset-lg-3 col-xl-9 offset-xl-2 px-0 zoom-out-main s-main-content">
              <div className="row" style={{ marginTop: "6.27rem" }}>
                <div
                  className="col-12 d-flex justify-content-center p-2 rounded"
                  style={{ marginBottom: "1rem", backgroundColor: "white" }}
                >
                  {/* TTODO: Check or modify brand logo -i */}
                  {/* <img
                    src={require("../../assets/itqan-education-logo.png")}
                    style={{ width: "50px" }}
                  /> */}
                  <div className="d-flex align-items-center mx-2">
                    {window.sys_app_translate(
                      "Are you interested working with us in private universities?",
                      lang
                    )}
                  </div>
                  <div className="d-flex align-items-center">
                    <AdWhatsappIcon
                      className="ad-icon"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        window.open(
                          "https://api.whatsapp.com/send?phone=" +
                          window.sys_app_translate(
                            "Page Ad Whatsapp Number",
                            lang
                          )
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="col-12 px-0">
                  {AppPathNames()[history.location.pathname] && (
                    <h3
                      className="inter inter-medium"
                      style={{
                        fontSize: "1rem",
                        marginBottom: "2.3rem",
                        marginLeft: "0.83rem",
                      }}
                    >
                      {AppPathNames()[history.location.pathname].map(
                        (item, key) => {
                          if (item === ">") {
                            return (
                              <PathJoinerIcon
                                key={"PathJoiner" + key}
                                style={{
                                  marginRight: "13.4px",
                                  marginLeft: "13.4px",
                                }}
                              />
                            );
                          } else {
                            if (key === 0) {
                              return (
                                <a
                                  key={"PathJoiner" + key}
                                  onClick={() => history.push("/app/home")}
                                  className="clickable-breadcrumb"
                                >
                                  {item}
                                </a>
                              );
                            } else {
                              return item;
                            }
                          }
                        }
                      )}
                    </h3>
                  )}

                  {this.renderPage()}
                  {this.renderSignalsPopup()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade itqan-overlay"></div>
      </ErrorBoundary>
    );
  }
}

//map state to props
const mapStateToProps = ({ settings, authUser, appReducer }) => {
  const { loading } = appReducer;
  const { user } = authUser;
  return { user, loading };
};

export default withRouter(
  connect(mapStateToProps, {
    logoutUser,
    handleAppError,
    setLoading,
    setAgencyBalance,
    setAgencyCredit,
    setAgencyPercentage,
    setAgencyProfit,
    setAgencyInfo,
  })(MainApp)
);